export const validatedFormatData = [
    'png',
    'gif',
    'jpg',
    'jpeg',
    'heic',
    'doc',
    'docx',
    'odt',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'pdf',
    'csv',
    'xml',
    'txt',
    'dwg',
    'dwt',
    'rtf',
    'dxf',
    'taf',
    'cdf',
    'dxx',
    'mdb',
    'dat',
    'arp',
    'smtr',
    'mp4',
    'mov',
    'wmv',
    'avi',
    'mp3',
    'm4a',
    'wav',
    'zip',
    'rar',
    '7z',
    'bzip2',
    'bz2',
    'gzip',
    'tar',
    'file.tar',
    'gz',
    'tar.gz',
] as const;
